<i18n src="@/locales/modules/DeviceTranslate.json"></i18n>

<template>
	<div :key="'default'" id="list-inventories" class="data-list-container">
		<div class="empty-data text-center" v-if="!inventories.length && !searchText && !isSearching">
			<p class="flex justify-center items-center flex-wrap">
				<span>Chưa có dữ liệu.</span>
			</p>
			<img src="@/assets/images/cbs/device/empty-list-data.png" alt class="responsive" />
		</div>

		<div v-else>
			<vs-table ref="table" :sst="true" :noDataText="$t('Notify.NoDataAvailable')" class="stack-table" :max-items="limit" :data="inventories" @sort="mixinHandleSort">
				<div slot="header" class="flex flex-grow justify-end">
					<cbs-input
						@input="mixinHandleSearch"
						size="large"
						class="input-search mr-3 md:block lg:block xl:block hidden"
						icon="search"
						:placeholder="$t('Actions.Search')"
						v-model="searchText"
					/>
				</div>

				<template slot="thead">
					<vs-th sort-key="name">{{ $t("InventoryName") }}</vs-th>
					<vs-th class="no-sorter">{{ $t("Street") }}</vs-th>
					<vs-th class="no-sorter"></vs-th>
				</template>

				<template slot-scope="{ data }">
					<tbody>
						<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" @click.native="handleClickDeviceItemRow($event, tr)">
							<vs-td :data-header="$t('InventoryName')">
								<p class="device-name font-medium">{{ tr.name }}</p>
							</vs-td>

							<vs-td :data-header="$t('Street')">
								<p class="device-inventory font-medium sm:truncate">{{ tr.street ? tr.street : "" }}</p>
							</vs-td>

							<vs-td class="text-right"> </vs-td>
						</vs-tr>
					</tbody>
				</template>
			</vs-table>
			<!-- <CbsPagination class="mt-3" :total="totalPages" v-model="currentPage" /> -->
		</div>
	</div>
</template>

<script>
import _ from "lodash";
import { syncQuery, detectLeavePage, withBasicQueries, devicePermissions, categoryPermissions, getUserPermissions, inventoryPermissions } from "@/mixins/mixins.js";
import moduleDevice from "@/store/device/moduleDevice";
import requestBasicHandlers from "@/mixins/requestBasicHandlers";

export default {
	mixins: [
		syncQuery,
		withBasicQueries,
		requestBasicHandlers,
		getUserPermissions({
			...devicePermissions,
			...categoryPermissions,
			...inventoryPermissions
		}),
		detectLeavePage("isRequestFormDirty")
	],
	components: {},
	data() {
		return {
			limit: 10,

			isSearching: false
		};
	},
	computed: {
		inventories() {
			return _.get(this.$store, "state.deviceManagement.inventories") || [];
		}
	},
	watch: {
		currentPage() {
			this.getListDevices();
		},
		"$route.query"(newVal, oldVal) {
			const newValClone = Object.assign({}, newVal);
			const oldValClone = Object.assign({}, oldVal);
			if (!newValClone.code) {
				delete oldValClone.code;
			}
			if (!_.isEqual(newValClone, oldValClone)) {
				this.getListInventory();
			}
		},
		"$route.path"(newVal, oldVal) {
			if (newVal !== oldVal) {
				this.getListInventory();
			}
		},
		pageTitleByCategoryId() {
			this.setPageTitleByCategoryId();
		},
		isShowRequestFormDialogMixin() {
			if (!this.isShowRequestFormDialogMixin) {
				this.handleSetIsFormDirty(false);
			}
		}
	},
	methods: {
		async getListInventory() {
			try {
				this.$vs.loading();
				await this.$store.dispatch("deviceManagement/fetchInventories", {
					limit: this.limit,
					page: this.currentPage,
					fetchPolicy: "no-cache"
				});
				this.$vs.loading.close();
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			}
		},
		showDeleteConfirm(id) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: this.$t("Notify.DeleteConfirm"),
				accept: () => this.deleteData(id),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel")
			});
		}
	},
	created() {
		this.$store.registerModule("deviceManagement", moduleDevice);
		this.getListInventory();
	},
	beforeDestroy() {
		this.$store.unregisterModule("deviceManagement");
	}
};
</script>

<style lang="scss">
@import "@/assets/scss/cbs/DevicesManagement.scss";
</style>
